import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'

export default function useRowsNestedRequestDetailsTable({ isSentRequest, requestResponse }) {
  const { t } = useTranslation()
  const [css] = useStyletron()

  const parseJson = value => {
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }

  const formatResponse = () => {
    const requestParsed = isSentRequest ? requestResponse : parseJson(requestResponse)
    return JSON.stringify(requestParsed, null, 2)
  }

  return {
    t,
    css,
    isSentRequest,
    formatResponse,
  }
}
